// frontend/src/config/idValidation.js
import { isValidDominicanID } from '../utils/validateDominicanID'

/**
 * Configuración por país para validar documentos de identidad.
 *
 * Cada entrada en "validators" representa un país utilizando su código ISO 
 * 3166-1 alpha-2. La configuración controla tanto la validación estructural 
 * (longitud, patrón, checksum) como la integración con servicios de padrón 
 * (registro civil o validadores remotos).
 *
 * Campos posibles en cada país:
 * - name: Nombre descriptivo del país.
 * - nationalIdLength: Longitud esperada del ID nacional.
 * - allowedPattern: Expresión regular permitida para el input.
 * - checksum: Si requiere validación por algoritmo (ej. Luhn o similar).
 * - validateAgainstPadron: Si debe consultarse un servicio externo.
 * - usesNationalRegistry: Si está vinculado a una fuente oficial.
 * - registryEndpoint: URL del padrón (cuando aplique).
 * - registryMethod: Verbo HTTP (ej. POST o GET).
 * - registryPayload: Función que construye el payload a enviar.
 * - validate: Función que implementa validación personalizada.
 * - message: Mensaje a mostrar si el ID es inválido.
 *
 * Notas:
 * - Si `validateAgainstPadron` no está definido o es false,
 *   no se realizará ninguna consulta externa desde el frontend.
 * - El campo `validate` debe devolver true o false según la validez.
 * - Este archivo es consumido por hooks como `useValidationConfig()`
 *   y funciones como `isNationalIdInvalid()`.
 */

export const ID_VALIDATION_CONFIG = {
  activeCountry: 'DO', // ISO 3166-1 alpha-2 (Rep. Dominicana)

  validators: {
    DO: {
      name: 'Dominican Republic',
      nationalIdLength: 11,
      allowedPattern: /^[0-9]{1,11}$/,
      checksum: true,
      validateAgainstPadron: true,
      usesNationalRegistry: true,
      registryEndpoint: 'https://brolly.local/api/padron/cedula',
      registryMethod: 'POST',
      registryPayload: (id) => ({ cedula: id }),
      validate: (value) => isValidDominicanID(value),
      message: 'Only Dominican ID numbers are accepted. They must contain exactly 11 digits and pass the official checksum validation. If this is not possible, please use a valid passport instead.'
    },
    // Ejemplo futuro:
    AR: {
      name: 'Argentina',
      nationalIdLength: 8,
      checksum: false,
      usesNationalRegistry: false
    }
  }
}
